import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'
import { HUB_TAPE, linePath } from './chart-candles'

const BODY_W = HUB_TAPE.pitch * 0.6

/**
 * Chart panel art: the shared candle tape (Chris's sketched day: a run, a
 * flush, a double bottom, a grind to the high) with one muted average
 * underneath. Same drawing as the History chart minus its day-zero marker,
 * because it is the same panel.
 */
export function ChartArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {/* One muted average under the tape. */}
      <path
        d={linePath(HUB_TAPE.average)}
        fill="none"
        stroke="hsl(var(--muted-foreground) / 0.55)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      {HUB_TAPE.candles.map(([cx, top, bottom, high, low, rising]) => {
        const tone = rising ? 'hsl(var(--chart-candle-up))' : 'hsl(var(--chart-candle-down))'
        return (
          <g key={cx}>
            <path
              d={`M${cx} ${high} V${low}`}
              stroke={tone}
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
            {/* Square bodies with a full-tone outline: crisp, strong edges. */}
            <rect
              x={cx - BODY_W / 2}
              y={top}
              width={BODY_W}
              height={Math.max(bottom - top, 1)}
              fill={tone}
              stroke={tone}
              strokeWidth="0.5"
            />
          </g>
        )
      })}
    </svg>
  )
}
